import Helper from './Helper';

// Layout styles
const LAYOUT_DECK_ON_LEFT = 1;
const LAYOUT_DECK_ON_RIGHT = 2;

// types
const LIFEFORM = 'species';
const APEX_PREDATOR = 'apex predator';
const WORLD_EVENT = 'event';
const ACTION = 'action';

// Event Outcomes
const EO_NONE = 'none';
const EO_ADD_TO_PLAY = 'Add to play';
const EO_ADD_PREDATOR_TO_PLAY = 'Add predator to play';
const EO_REMOVE_TWO_ICE = 'Remove two ice';
const EO_REMOVE_THREE_ICE = 'Remove three ice';
const EO_ADD_ONE_ICE = 'Add one ice';
const EO_ADD_TWO_ICE = 'Add two ice';
const EO_PROTECT_SPECIES = 'Protect a Species';
const EO_REMOVE_SPECIES = 'Remove Species';
const EO_INVASIVE_WHALES = 'Invasive Whales'
const EO_OCEAN_ACID = 'Ocean Acid';
const EO_OVER_HARVESTING = 'Over Harvesting'

const TROPHIC_LEVEL_ONE = 1;
const TROPHIC_LEVEL_TWO = 2;
const TROPHIC_LEVEL_THREE = 3;
const TROPHIC_LEVEL_FOUR = 4;
const TROPHIC_LEVEL_FIVE = 5;

const DUMMY_INITIALIZER_CARD = {
    type: '',
    name: '',
    img: '',
    needsIce: 0,
    diet: [],
    resolution: ''
}

// Cards
    // Ice
const ICE = 'Ice';
const ICE_IMG = './assets/ice.png';
const ICE_CARD = {
    type: ICE,
    name: ICE,
    img: ICE_IMG,
    needsIce: 0,
    diet: [],
    resolution: EO_NONE
};

    // Ice Algea
const ICE_ALGEA = 'Ice Algae';
const ICE_ALGEA_SYMBOL ='IA';
const ICE_ALGEA_DIET = [];
const ICE_ALGEA_IMG = './assets/ice-algae.png';
const ICE_ALGEA_CARD = {
    type: LIFEFORM,
    name: ICE_ALGEA,
    img: ICE_ALGEA_IMG,
    needsIce: 1,
    diet: ICE_ALGEA_DIET,
    resolution: EO_ADD_TO_PLAY,
    symbol: ICE_ALGEA_SYMBOL,
    facts: 'Ice algae are primary producers that grow directly on sea ice.',
    trophicLevel: TROPHIC_LEVEL_ONE,
};

    // Phyto-plankton
const PHYTO_PLANKTON = 'Phytoplankton';
const PHYTO_PLANKTON_SYMBOL = 'P';
const PHYTO_PLANKTON_DIET = [];
const PHYTO_PLANKTON_CARD = {
    type: LIFEFORM,
    name: PHYTO_PLANKTON,
    diet: PHYTO_PLANKTON_DIET,
    img: '',
    needsIce: 0,
    symbol: PHYTO_PLANKTON_SYMBOL,
    facts: 'Phytoplankton are primary producers and need nutrients, sunlight and stability to grow in seawater.',
    trophicLevel: TROPHIC_LEVEL_ONE,
}

// Ice Copepod
const ICE_COPEPOD = 'Ice Copepod';
const ICE_COPEPOD_SYMBOL = 'IC';
const ICE_COPEPOD_IMG = '';
const ICE_COPEPOD_DIET = [
    {name: ICE_ALGEA_SYMBOL, trophicLevel: 1, fullName: ICE_ALGEA},
];
const ICE_COPEPOD_CARD = {
    type: LIFEFORM,
    name: ICE_COPEPOD,
    img: ICE_COPEPOD_IMG,
    needsIce: 0,
    diet: ICE_COPEPOD_DIET,
    symbol: ICE_COPEPOD_SYMBOL,
    facts: 'The bodies of ice copepods are up to 70% fat to help them survive the long Arctic winters.',
    trophicLevel: TROPHIC_LEVEL_TWO,
};

    // Krill
const KRILL = 'Krill';
const KRILL_SYMBOL = 'K';
const KRILL_IMG = './assets/krill.png';
const KRILL_DIET = [
    {name: ICE_ALGEA_SYMBOL, trophicLevel: 1, fullName: ICE_ALGEA},
    {name: PHYTO_PLANKTON_SYMBOL, trophicLevel: 1, fullName: PHYTO_PLANKTON},
    // {name: KRILL_SYMBOL, trophicLevel: 2, fullName: KRILL},
    {name: ICE_COPEPOD_SYMBOL, trophicLevel: 2, fullName: ICE_COPEPOD},
];
const KRILL_CARD = {
    type: LIFEFORM,
    name: KRILL,
    img: KRILL_IMG,
    needsIce: 0,
    diet: KRILL_DIET,
    resolution: EO_ADD_TO_PLAY,
    symbol: KRILL_SYMBOL,
    facts: 'These tiny shrimp-like creatures are a primary food source for many whales, seabirds, fish, squid & seals',
    trophicLevel: TROPHIC_LEVEL_TWO,
};

    // Clam
const CLAM = 'Clam';
const CLAM_SYMBOL = 'C';
const CLAM_IMG = '';
const CLAM_DIET = [
    {name: ICE_ALGEA_SYMBOL, trophicLevel: 1, fullName: ICE_ALGEA},
    {name: PHYTO_PLANKTON_SYMBOL, trophicLevel: 1, fullName: PHYTO_PLANKTON},
];
const CLAM_CARD = {
    type: LIFEFORM,
    name: CLAM,
    img: CLAM_IMG,
    needsIce: 0,
    diet: CLAM_DIET,
    symbol: CLAM_SYMBOL,
    facts: 'Clams live in seafloor sediment, remaining connected to the water through snorkel-like siphons.',
    trophicLevel: TROPHIC_LEVEL_TWO,
};

    // Arctic Cod
const ARCTIC_COD = 'Arctic Cod';
const ARCTIC_COD_SYMBOL = 'AC';
const ARCTIC_COD_IMG = './assets/arctic-cod.png';
const ARCTIC_COD_DIET = [
    {name: KRILL_SYMBOL, trophicLevel: 2, fullName: KRILL},
    {name: ICE_COPEPOD_SYMBOL, trophicLevel: 2, fullName: ICE_COPEPOD}
];
const ARCTIC_COD_CARD = {
    type: LIFEFORM,
    name: ARCTIC_COD,
    img: ARCTIC_COD_IMG,
    diet: ARCTIC_COD_DIET,
    needsIce: 1,
    symbol: ARCTIC_COD_SYMBOL,
    facts: 'Sea ice contains nooks and crannies that provide the Arctic Cod refuge from predators.',
    trophicLevel: TROPHIC_LEVEL_THREE,
};

    // Squid
const SQUID = 'Squid';
const SQUID_SYMBOL = 'S';
const SQUID_IMG = '';
const SQUID_DIET = [
    {name: ICE_COPEPOD_SYMBOL, trophicLevel: 2, fullName: ICE_COPEPOD},
    {name: KRILL_SYMBOL, trophicLevel: 2, fullName: KRILL},
    {name: ARCTIC_COD_SYMBOL, trophicLevel: 3, fullName: ARCTIC_COD},
];
const SQUID_CARD = {
    type: LIFEFORM,
    name: SQUID,
    img: SQUID_IMG,
    needsIce: 0,
    diet: SQUID_DIET,
    symbol: SQUID_SYMBOL,
    facts: 'Squid chase down their prey and capture them using suckers on their tentacles.',
    trophicLevel: TROPHIC_LEVEL_THREE,
};

    // Ringed Seal
const RINGED_SEAL = 'Ringed Seal';
const RINGED_SEAL_SYMBOL = 'RS';
const RINGED_SEAL_IMG = '';
const RINGED_SEAL_DIET = [
    {name: KRILL_SYMBOL, trophicLevel: 2, fullName: KRILL},
    {name: ICE_COPEPOD_SYMBOL, trophicLevel: 2, fullName: ICE_COPEPOD},
    {name: ARCTIC_COD_SYMBOL, trophicLevel: 3, fullName: ARCTIC_COD},
    // {name: SQUID_SYMBOL, trophicLevel: 3, fullName: SQUID},
];
const RINGED_SEAL_CARD = {
    type: LIFEFORM,
    name: RINGED_SEAL,
    img: RINGED_SEAL_IMG,
    needsIce: 2,
    diet: RINGED_SEAL_DIET,
    symbol: RINGED_SEAL_SYMBOL,
    facts: 'Ringed seals spend much of their lives on sea ice, giving birth and raising pups in dens under the snow.',
    trophicLevel: TROPHIC_LEVEL_FOUR,
};

    // Bearded Seal
const BEARDED_SEAL = 'Bearded Seal';
const BEARDED_SEAL_SYMBOL = 'BS';
const BEARDED_SEAL_IMG = '';
const BEARDED_SEAL_DIET = [
    {name: CLAM_SYMBOL, trophicLevel: 2, fullName: CLAM},
    {name: ARCTIC_COD_SYMBOL, trophicLevel: 3, fullName: ARCTIC_COD},
];
const BEARDED_SEAL_CARD = {
    type: LIFEFORM,
    name: BEARDED_SEAL,
    img: BEARDED_SEAL_IMG,
    needsIce: 2,
    diet: BEARDED_SEAL_DIET,
    symbol: BEARDED_SEAL_SYMBOL,
    facts: 'Bearded seals use prominent whiskers to feel along the soft bottom sediment for prey.',
    trophicLevel: TROPHIC_LEVEL_FOUR,
};

    // Beluga Whale
const BELUGA_WHALE = 'Beluga Whale';
const BELUGA_WHALE_SYMBOL = 'BeW';
const BELUGA_WHALE_IMG = '';
const BELUGA_WHALE_DIET = [
    {name: ARCTIC_COD_SYMBOL, trophicLevel: 3, fullName: ARCTIC_COD},
    {name: SQUID_SYMBOL, trophicLevel: 3, fullName: SQUID},
];
const BELUGA_WHALE_CARD = {
    type: LIFEFORM,
    name: BELUGA_WHALE,
    img: BELUGA_WHALE_IMG,
    needsIce: 0,
    diet: BELUGA_WHALE_DIET,
    symbol: BELUGA_WHALE_SYMBOL,
    facts: 'Belugas are social creatures that can live, hunt, and migrate in groups of up to several hundred.',
    trophicLevel: TROPHIC_LEVEL_FOUR,
};

    // Bowhead Whale
const BOWHEAD_WHALE = 'Bowhead Whale';
const BOWHEAD_WHALE_SYMBOL = 'BoW';
const BOWHEAD_WHALE_IMG = '';
const BOWHEAD_WHALE_DIET = [
    {name: KRILL_SYMBOL, trophicLevel: 2, fullName: KRILL},
    {name: ICE_COPEPOD_SYMBOL, trophicLevel: 2, fullName: ICE_COPEPOD},
];
const BOWHEAD_WHALE_CARD = {
    type: LIFEFORM,
    name: BOWHEAD_WHALE,
    img: BOWHEAD_WHALE_IMG,
    needsIce: 0,
    diet: BOWHEAD_WHALE_DIET,
    symbol: BOWHEAD_WHALE_SYMBOL,
    facts: 'If trapped under the ice and in need of air, Bowhead whales can break through up to 61 cm of ice.',
    trophicLevel: TROPHIC_LEVEL_FOUR,
};

    // Narwhal
const NARWHAL = 'Narwhal';
const NARWHAL_SYMBOL = 'NW';
const NARWHAL_IMG = './assets/narwhal.png';
const NARWHAL_DIET = [
    {name:ARCTIC_COD_SYMBOL, trophicLevel: 3, fullName: ARCTIC_COD},
    {name:SQUID_SYMBOL, trophicLevel: 3, fullName: SQUID},
];
const NARWHAL_CARD = {
    type: LIFEFORM,
    name: NARWHAL,
    img: NARWHAL_IMG,
    needsIce: 0,
    diet: NARWHAL_DIET,
    symbol: NARWHAL_SYMBOL,
    facts: 'Male Narwhals have a long ivory tusk that spirals counter-clockwise from their head.',
    trophicLevel: TROPHIC_LEVEL_FOUR,
};

    // Eider Duck
const EIDER_DUCK = 'Eider Duck';
const EIDER_DUCK_SYMBOL = 'ED';
const EIDER_DUCK_IMG = '';
const EIDER_DUCK_DIET = [
    {name:CLAM_SYMBOL, trophicLevel: 2, fullName: CLAM},
];
const EIDER_DUCK_CARD = {
    type: LIFEFORM,
    name: EIDER_DUCK,
    img: EIDER_DUCK_IMG,
    needsIce: 0,
    diet: EIDER_DUCK_DIET,
    symbol: EIDER_DUCK_SYMBOL,
    facts: 'Eider down is highly valued as one of the lightest and most effective insulators known.',
    trophicLevel: TROPHIC_LEVEL_FOUR,
};

    // Walrus
const WALRUS = 'Walrus';
const WALRUS_SYMBOL = 'W';
const WALRUS_IMG = '';
const WALRUS_DIET = [
    {name:CLAM_SYMBOL, trophicLevel: 2, fullName: CLAM},
];
const WALRUS_CARD = {
    type: LIFEFORM,
    name: WALRUS,
    img: WALRUS_IMG,
    needsIce: 2,
    diet: WALRUS_DIET,
    symbol: WALRUS_SYMBOL,
    facts: 'Walruses heft their large bodies, up to 1,900 kg, on to sea ice to rest and drift to new feeding grounds.',
    trophicLevel: TROPHIC_LEVEL_FOUR,
};

    // Human
const HUMAN = 'Human Being';
const HUMAN_IMG = './assets/human.png';
const HUMAN_SYMBOL = 'HB';
const HUMAN_DIET = [
    {name: EIDER_DUCK_SYMBOL, trophicLevel: 4, fullName: EIDER_DUCK},
    {name: BEARDED_SEAL_SYMBOL, trophicLevel: 4, fullName: BEARDED_SEAL},
    {name: RINGED_SEAL_SYMBOL, trophicLevel: 4, fullName: RINGED_SEAL},
    {name: WALRUS_SYMBOL, trophicLevel: 4, fullName: WALRUS},
    {name: BOWHEAD_WHALE_SYMBOL, trophicLevel: 4, fullName: BOWHEAD_WHALE},
    {name: BELUGA_WHALE_SYMBOL, trophicLevel: 4, fullName: BELUGA_WHALE},
    {name: NARWHAL_SYMBOL, trophicLevel: 4, fullName: NARWHAL},
    {name: ARCTIC_COD_SYMBOL, trophicLevel: 3, fullName: ARCTIC_COD},
];
const HUMAN_CARD = {
    type: APEX_PREDATOR,
    name: HUMAN,
    img: HUMAN_IMG,
    diet: HUMAN_DIET,
    symbol: HUMAN_SYMBOL,
    resolution: EO_ADD_PREDATOR_TO_PLAY,
    facts: 'Subsistence hunting and fishing play a key role in the way of life for many Arctic Indigenous people.',
    trophicLevel: TROPHIC_LEVEL_FIVE,
};

    // Polar Bear
const POLAR_BEAR = 'Polar Bear';
const POLAR_BEAR_IMG = 'png';
const POLAR_BEAR_SYMBOL = 'PB';
const POLAR_BEAR_DIET = [
    {name: BEARDED_SEAL_SYMBOL, trophicLevel: 4, fullName: BEARDED_SEAL},
    {name: RINGED_SEAL_SYMBOL, trophicLevel: 4, fullName: RINGED_SEAL}
];
const POLAR_BEAR_CARD = {
    type: APEX_PREDATOR,
    name: POLAR_BEAR,
    img: POLAR_BEAR_IMG,
    diet: POLAR_BEAR_DIET,
    symbol: POLAR_BEAR_SYMBOL,
    resolution: EO_ADD_PREDATOR_TO_PLAY,
    facts: 'Polar bears, highly dependent on sea ice, are threatened by global warming due to loss of habitat and prey.',
    trophicLevel: TROPHIC_LEVEL_FIVE,
};

    // Carbon pullution
const CARBON_POLLUTION = 'Carbon Pollution';
const CARBON_POLLUTION_SYMBOL = '-2';
const CARBON_POLLUTION_CARD_ONE = {
    type: WORLD_EVENT,
    footer: 'Warming',
    blockerText: 'Must melt ice to continue',
    name: CARBON_POLLUTION,
    img: 'e01',
    diet: [],
    resolution: EO_REMOVE_TWO_ICE,
    symbol: CARBON_POLLUTION_SYMBOL,
    iceDestroyed: 0,
    facts: 'When coal, oil, and gas are burned to produce energy and electricity, they release carbon pollution that contributes to global warming.',
};
const CARBON_POLLUTION_CARD_TWO = {
    type: WORLD_EVENT,
    footer: 'Warming',
    blockerText: 'Must melt ice to continue',
    name: CARBON_POLLUTION,
    img: 'e02',
    diet: [],
    resolution: EO_REMOVE_TWO_ICE,
    symbol: CARBON_POLLUTION_SYMBOL,
    iceDestroyed: 0,
    facts: 'Carbon pollution from cars, trucks, SUV’s, and other passenger vehicles rapidly increases as more people choose to drive.',
};
const CARBON_POLLUTION_CARD_THREE = {
    type: WORLD_EVENT,
    footer: 'Warming',
    blockerText: 'Must melt ice to continue',
    name: CARBON_POLLUTION,
    img: 'e03',
    diet: [],
    resolution: EO_REMOVE_TWO_ICE,
    symbol: CARBON_POLLUTION_SYMBOL,
    iceDestroyed: 0,
    facts: 'Homes and businesses use large amounts of fossil fuel energy for heating, cooling, and lighting needs.',
};
const CARBON_POLLUTION_CARD_FOUR = {
    type: WORLD_EVENT,
    footer: 'Warming',
    blockerText: 'Must melt ice to continue',
    name: CARBON_POLLUTION,
    img: 'e04',
    diet: [],
    resolution: EO_REMOVE_TWO_ICE,
    symbol: CARBON_POLLUTION_SYMBOL,
    iceDestroyed: 0,
    facts: 'The use of fossil fuel energy for the production and distribution of consumer goods results in increased carbon pollution.',
};

const RAPID_SEA_ICE_LOSS_CARD = {
    type: WORLD_EVENT,
    footer: 'Warming',
    blockerText: 'Must melt ice to continue',
    name: 'Rapid Sea Ice Loss',
    img: 'e04',
    diet: [],
    resolution: EO_REMOVE_THREE_ICE,
    symbol: CARBON_POLLUTION_SYMBOL,
    iceDestroyed: 0,
    facts: 'Unusually warm summer temperatures heat up ocean waters and cause widespread melting of sea ice.',
};

const SPECIES_EVENT_SYMBOL = '×';

const INVASIVE_KILLER_WHALE_TARGETS = [BEARDED_SEAL, RINGED_SEAL, BELUGA_WHALE, EIDER_DUCK, ARCTIC_COD, NARWHAL]
const INVASIVE_KILLER_WHALE_DIET = [
    {name: RINGED_SEAL_SYMBOL, trophicLevel: 4, fullName: RINGED_SEAL},
    {name: BEARDED_SEAL_SYMBOL, trophicLevel: 4, fullName: BEARDED_SEAL},
    {name: BELUGA_WHALE_SYMBOL, trophicLevel: 4, fullName: BELUGA_WHALE},
    {name: EIDER_DUCK_SYMBOL, trophicLevel: 4, fullName: EIDER_DUCK},
    {name: NARWHAL_SYMBOL, trophicLevel: 4, fullName: NARWHAL},
    {name: ARCTIC_COD_SYMBOL, trophicLevel: 3, fullName: ARCTIC_COD},
]
const INVASIVE_KILLER_WHALE_CARD = {
    type: WORLD_EVENT,
    footer: 'Migration',
    blockerText: 'Killer whales must attack to continue',
    name: 'Invasive Killer Whale',
    img: 's01',
    diet: INVASIVE_KILLER_WHALE_DIET,
    symbol: SPECIES_EVENT_SYMBOL,
    resolution: EO_INVASIVE_WHALES,
    validTargets: INVASIVE_KILLER_WHALE_TARGETS,
    facts: 'As sea ice retreats, Orca Whales will move further north, threatening several large marine mammals.\n To play this card, drop it on a column with any of the following species: ' + INVASIVE_KILLER_WHALE_TARGETS.join (', '),
}

const OCEAN_ACIDIFICATION_DIET = [
    {name: ICE_COPEPOD_SYMBOL, trophicLevel: 2, fullName: ICE_COPEPOD},
    {name: KRILL_SYMBOL, trophicLevel: 2, fullName: KRILL},
    {name: CLAM_SYMBOL, trophicLevel: 2, fullName: CLAM},
]
const OCEAN_ACIDIFICATION_CARD = {
    type: WORLD_EVENT,
    footer: 'Weakens shells & skeletons',
    name: 'Ocean Acidification',
    img: 's02',
    diet: OCEAN_ACIDIFICATION_DIET,
    symbol: SPECIES_EVENT_SYMBOL,
    resolution: EO_OCEAN_ACID,
    validTargets: [ICE_COPEPOD, KRILL, CLAM],
    facts: 'Changes in the ocean\'s pH level, caused by rising CO2 levels, may weaken or kill clams and some zooplankton.\n To play this card, drop it into a column with either Ice Copepods, krill, or clams.',
}

const OVER_HARVESTING_TARGETS = [WALRUS, BEARDED_SEAL, RINGED_SEAL, BOWHEAD_WHALE, BELUGA_WHALE, EIDER_DUCK, ARCTIC_COD, NARWHAL];
// Design changes in the cards now calls for "dietary" icons on the events, this may seem redundant, but that is due to poor planning on my part and the design goals of this app changing as it was being worked on
const OVER_HARVESTING_DIET = [
    {name: WALRUS_SYMBOL, trophicLevel: 4, fullName: WALRUS},
    {name: RINGED_SEAL_SYMBOL, trophicLevel: 4, fullName: RINGED_SEAL},
    {name: BEARDED_SEAL_SYMBOL, trophicLevel: 4, fullName: BEARDED_SEAL},
    {name: BOWHEAD_WHALE_SYMBOL, trophicLevel: 4, fullName: BOWHEAD_WHALE},
    {name: BELUGA_WHALE_SYMBOL, trophicLevel: 4, fullName: BELUGA_WHALE},
    {name: NARWHAL_SYMBOL, trophicLevel: 4, fullName: NARWHAL},
    {name: EIDER_DUCK_SYMBOL, trophicLevel: 4, fullName: EIDER_DUCK},
    {name: ARCTIC_COD_SYMBOL, trophicLevel: 3, fullName: ARCTIC_COD},
]
const OVER_HARVESTING_CARD = {
    type: WORLD_EVENT,
    name: 'Overharvesting',
    img: 's03',
    diet: OVER_HARVESTING_DIET,
    symbol: SPECIES_EVENT_SYMBOL,
    resolution: EO_OVER_HARVESTING,
    validTargets: OVER_HARVESTING_TARGETS,
    facts: 'Overharvesting occurs when larger numbers of a species are killed than the population can replace through natural reproduction.\n To play this card, drop it into a column with any of the following species: ' + OVER_HARVESTING_TARGETS.join (', '),
}

    // Green Transportation
const ACTION_SYMBOL = '+1 ice'
const GREEN_TRANSPORTATION = 'Green Transportation';
const GREEN_TRANSPORTATION_IMG = '';
const GREEN_TRANSPORTATION_CARD = {
    type: ACTION,
    name: GREEN_TRANSPORTATION,
    img: GREEN_TRANSPORTATION_IMG,
    footer: 'Action',
    diet: [],
    symbol: ACTION_SYMBOL,
    resolution: EO_ADD_ONE_ICE,
    facts: 'Walking, biking, carpooling and using public transportation help combat global warming by cutting down on carbon pollution.'
};

    // Alternate Energy
const ALTERNATE_ENERGY = 'Alternate Energy';
const ALTERNATE_ENERGY_IMG = '';
const ALTERNATE_ENERGY_CARD = {
    type: ACTION,
    name: ALTERNATE_ENERGY,
    img: ALTERNATE_ENERGY_IMG,
    footer: 'Action',
    diet: [],
    symbol: ACTION_SYMBOL,
    resolution: EO_ADD_ONE_ICE,
    facts: 'Solar, wind, geothermal, and nuclear energy sources are used to produce clean energy and electricity that helps prevent global warming.',
};

    // Energy Efficiency
const ENERGY_EFFICIENCY = 'Energy Efficiency';
const ENERGY_EFFICIENCY_IMG = '';
const ENERGY_EFFICIENCY_CARD = {
    type: ACTION,
    name: ENERGY_EFFICIENCY,
    img: ENERGY_EFFICIENCY_IMG,
    footer: 'Action',
    diet: [],
    symbol: ACTION_SYMBOL,
    resolution: EO_ADD_ONE_ICE,
    facts: 'Homes and businesses use less energy when they improve building insulation and use energy-efficient appliances and products.',
};

    // Sea Ice Restoration
const SEA_ICE_RESTORATION = 'Carbon Capture and Sequestration';
const SEA_ICE_RESTORATION_IMG = '';
const SEA_ICE_RESTORATION_CARD = {
    type: ACTION,
    name: SEA_ICE_RESTORATION,
    img: SEA_ICE_RESTORATION_IMG,
    footer: 'Action',
    diet: [],
    symbol: '+2 ice',
    resolution: EO_ADD_TWO_ICE,
    facts: 'Trapping and storing carbon pollution reduces global warming, allowing for increased amounts of sea ice.',
};

// const PROTECT_A_SPECIES = 'Protect Species';
const PROTECT_A_SPECIES = 'Protect From Overharvesting';
const PROTECT_A_SPECIES_IMG = './assets/protect-a-species.png';
const PROTECT_A_SPECIES_DIET = [
    {name: WALRUS_SYMBOL, trophicLevel: 4, fullName: WALRUS},
    {name: RINGED_SEAL_SYMBOL, trophicLevel: 4, fullName: RINGED_SEAL},
    {name: BEARDED_SEAL_SYMBOL, trophicLevel: 4, fullName: BEARDED_SEAL},
    {name: BOWHEAD_WHALE_SYMBOL, trophicLevel: 4, fullName: BOWHEAD_WHALE},
    {name: BELUGA_WHALE_SYMBOL, trophicLevel: 4, fullName: BELUGA_WHALE},
    {name: NARWHAL_SYMBOL, trophicLevel: 4, fullName: NARWHAL},
    {name: EIDER_DUCK_SYMBOL, trophicLevel: 4, fullName: EIDER_DUCK},
    {name: ARCTIC_COD_SYMBOL, trophicLevel: 3, fullName: ARCTIC_COD},
]
const PROTECT_A_SPECIES_CARD = {
    type: ACTION,
    name: PROTECT_A_SPECIES,
    img: PROTECT_A_SPECIES_IMG,
    resolution: EO_PROTECT_SPECIES,
    symbol: '',
    diet: PROTECT_A_SPECIES_DIET,
    validTargets: [
        ARCTIC_COD, SQUID, BOWHEAD_WHALE, BELUGA_WHALE, NARWHAL, RINGED_SEAL, BEARDED_SEAL, EIDER_DUCK, WALRUS
    ],
    facts: 'Legislation manages hunting and ﬁshing using community- and ecosystem-based management.',
}

export default {

    // Stuff that appears on the landing screen
    loadingScreenTextTitle: 'Sustain as many species as possible!',
    loadingScreenTextBody: `<div>Strategically manage your sea ice</div>
    <div>to support Arctic marine life</div>`,

    types: {
        lifeform: LIFEFORM,
        apexPredator: APEX_PREDATOR,
        worldEvent: WORLD_EVENT,
        action: ACTION,
    },
    resolutions: {
        addIce: EO_ADD_ONE_ICE,
        iceRestoration: EO_ADD_TWO_ICE,
        removeIce: EO_REMOVE_TWO_ICE,
        rapidSeaIceLoss: EO_REMOVE_THREE_ICE,
        protectSpecies: EO_PROTECT_SPECIES,
        removeSpecies: EO_REMOVE_SPECIES,
        oceanAcid: EO_OCEAN_ACID,
        overHarvesting: EO_OVER_HARVESTING,
        invasiveWhales: EO_INVASIVE_WHALES,
    },
    gameModes: ['normal'],
    // This layout option broke once styling was implemented
    layout: LAYOUT_DECK_ON_LEFT,

    // Static reference to card information for checking what card is what during run-time
    cards: {
        ice: ICE_CARD,
        carbonPollution: CARBON_POLLUTION_CARD_ONE,
        protectASpecies: PROTECT_A_SPECIES_CARD,
        overHarvesting: OVER_HARVESTING_CARD,
        invasiveKillerWhale: INVASIVE_KILLER_WHALE_CARD,
        oceanAcidification: OCEAN_ACIDIFICATION_CARD,
        phytoPlankton: PHYTO_PLANKTON_CARD,
        iceAlgea: ICE_ALGEA_CARD,

        rapidSeaIceLoss: RAPID_SEA_ICE_LOSS_CARD,
        seaIceRestoration: SEA_ICE_RESTORATION_CARD,
    },
    initialPlayAreas: [
        {
            iceColumn1: [
                Helper.clone (ICE_ALGEA_CARD),
                Helper.clone (ICE_COPEPOD_CARD),
                Helper.clone (ARCTIC_COD_CARD),
            ],
            iceColumn2: [
                Helper.clone (ICE_ALGEA_CARD),
                Helper.clone (ICE_COPEPOD_CARD),
            ],
            iceColumn3: [
                // Helper.clone (ICE_ALGEA_CARD),
                // Helper.clone (ICE_COPEPOD_CARD),

            ],
            iceColumn4: [],
            iceColumn5: [],
            iceColumn6: [
                Helper.clone (PHYTO_PLANKTON_CARD),
                Helper.clone (KRILL_CARD),
            ],
            iceColumn7: [
                Helper.clone (PHYTO_PLANKTON_CARD),
                Helper.clone (KRILL_CARD),
            ],
        },

        {
            iceColumn1: [
                Helper.clone (ICE_ALGEA_CARD),
                Helper.clone (ICE_COPEPOD_CARD),
            ],
            iceColumn2: [
                Helper.clone (ICE_ALGEA_CARD),
                Helper.clone (ICE_COPEPOD_CARD),
            ],
            iceColumn3: [
                Helper.clone (ICE_ALGEA_CARD),
                Helper.clone (ICE_COPEPOD_CARD),
            ],
            iceColumn4: [],
            iceColumn5: [],
            iceColumn6: [
                Helper.clone (PHYTO_PLANKTON_CARD),
                Helper.clone (KRILL_CARD),
            ],
            iceColumn7: [
                Helper.clone (PHYTO_PLANKTON_CARD),
                Helper.clone (KRILL_CARD),
            ],
        },
        {
            iceColumn1: [
                Helper.clone (ICE_ALGEA_CARD),
                Helper.clone (ICE_COPEPOD_CARD),
            ],
            iceColumn2: [
                Helper.clone (ICE_ALGEA_CARD),
                Helper.clone (ICE_COPEPOD_CARD),
            ],
            iceColumn3: [
                // Helper.clone (CLAM_CARD),
            ],
            iceColumn4: [],
            iceColumn5: [
                Helper.clone (PHYTO_PLANKTON_CARD),
                Helper.clone (KRILL_CARD),
            ],
            iceColumn6: [
                Helper.clone (PHYTO_PLANKTON_CARD),
                Helper.clone (KRILL_CARD),

            ],
            iceColumn7: [
                Helper.clone (PHYTO_PLANKTON_CARD),
                Helper.clone (KRILL_CARD),

            ],
        },
        {
            iceColumn1: [
                Helper.clone (ICE_ALGEA_CARD),
                Helper.clone (ICE_COPEPOD_CARD),
                Helper.clone (ARCTIC_COD_CARD),
            ],
            iceColumn2: [
                Helper.clone (ICE_ALGEA_CARD),
            ],
            iceColumn3: [
                // Helper.clone (CLAM_CARD),
            ],
            iceColumn4: [],
            iceColumn5: [
                Helper.clone (PHYTO_PLANKTON_CARD),
            ],
            iceColumn6: [
                Helper.clone (PHYTO_PLANKTON_CARD),
                Helper.clone (CLAM_CARD),
            ],
            iceColumn7: [
                Helper.clone (PHYTO_PLANKTON_CARD),
                Helper.clone (KRILL_CARD),

            ],
        },
        {
            iceColumn1: [
                Helper.clone (ICE_ALGEA_CARD),
                Helper.clone (ICE_COPEPOD_CARD),
                Helper.clone (ARCTIC_COD_CARD),
            ],
            iceColumn2: [
                Helper.clone (ICE_ALGEA_CARD),
                Helper.clone (ICE_COPEPOD_CARD),
                Helper.clone (ARCTIC_COD_CARD),
            ],
            iceColumn3: [
                Helper.clone (ICE_ALGEA_CARD),
                Helper.clone (ICE_COPEPOD_CARD),
            ],
            iceColumn4: [
                Helper.clone (ICE_ALGEA_CARD),
            ],
            iceColumn5: [
                Helper.clone (PHYTO_PLANKTON_CARD),
            ],
            iceColumn6: [
                Helper.clone (PHYTO_PLANKTON_CARD),

            ],
            iceColumn7: [
                Helper.clone (PHYTO_PLANKTON_CARD),
                Helper.clone (KRILL_CARD),

            ],
        },

    ],
    decks: {
        // Deck is shuffled at playtime
        normal: [
            // species
                // This dummy card needs to be the first card in every deck
            Helper.clone (DUMMY_INITIALIZER_CARD),
            Helper.clone (ICE_ALGEA_CARD),
            Helper.clone (ICE_ALGEA_CARD),
            Helper.clone (ICE_ALGEA_CARD),
            Helper.clone (ICE_ALGEA_CARD),
            Helper.clone (ICE_ALGEA_CARD),
            Helper.clone (ICE_ALGEA_CARD),
            Helper.clone (ICE_ALGEA_CARD),
            Helper.clone (ICE_ALGEA_CARD),
            Helper.clone (ICE_ALGEA_CARD),
            Helper.clone (PHYTO_PLANKTON_CARD),
            Helper.clone (PHYTO_PLANKTON_CARD),
            Helper.clone (PHYTO_PLANKTON_CARD),
            Helper.clone (PHYTO_PLANKTON_CARD),
            Helper.clone (PHYTO_PLANKTON_CARD),
            Helper.clone (PHYTO_PLANKTON_CARD),
            Helper.clone (PHYTO_PLANKTON_CARD),
            Helper.clone (PHYTO_PLANKTON_CARD),
            Helper.clone (KRILL_CARD),
            Helper.clone (KRILL_CARD),
            Helper.clone (KRILL_CARD),
            Helper.clone (KRILL_CARD),
            Helper.clone (KRILL_CARD),
            Helper.clone (KRILL_CARD),
            Helper.clone (CLAM_CARD),
            Helper.clone (CLAM_CARD),
            Helper.clone (CLAM_CARD),
            Helper.clone (CLAM_CARD),
            Helper.clone (CLAM_CARD),
            Helper.clone (CLAM_CARD),
            Helper.clone (ICE_COPEPOD_CARD),
            Helper.clone (ICE_COPEPOD_CARD),
            Helper.clone (ICE_COPEPOD_CARD),
            Helper.clone (ICE_COPEPOD_CARD),
            Helper.clone (ICE_COPEPOD_CARD),
            Helper.clone (ICE_COPEPOD_CARD),
            Helper.clone (ARCTIC_COD_CARD),
            Helper.clone (ARCTIC_COD_CARD),
            Helper.clone (ARCTIC_COD_CARD),
            Helper.clone (ARCTIC_COD_CARD),
            Helper.clone (SQUID_CARD),
            Helper.clone (SQUID_CARD),
            Helper.clone (SQUID_CARD),
            Helper.clone (SQUID_CARD),
            Helper.clone (BELUGA_WHALE_CARD),
            Helper.clone (BELUGA_WHALE_CARD),
            Helper.clone (RINGED_SEAL_CARD),
            Helper.clone (RINGED_SEAL_CARD),
            Helper.clone (BEARDED_SEAL_CARD),
            Helper.clone (BEARDED_SEAL_CARD),
            Helper.clone (BOWHEAD_WHALE_CARD),
            Helper.clone (BOWHEAD_WHALE_CARD),
            Helper.clone (NARWHAL_CARD),
            Helper.clone (NARWHAL_CARD),
            Helper.clone (EIDER_DUCK_CARD),
            Helper.clone (EIDER_DUCK_CARD),
            Helper.clone (WALRUS_CARD),
            Helper.clone (WALRUS_CARD),

            // Events
            Helper.clone (CARBON_POLLUTION_CARD_ONE),
            Helper.clone (CARBON_POLLUTION_CARD_THREE),
            Helper.clone (CARBON_POLLUTION_CARD_TWO),
            Helper.clone (CARBON_POLLUTION_CARD_FOUR),

            Helper.clone (INVASIVE_KILLER_WHALE_CARD),
            Helper.clone (OCEAN_ACIDIFICATION_CARD),
            Helper.clone (OVER_HARVESTING_CARD),

            // Actions
            Helper.clone (PROTECT_A_SPECIES_CARD),
            Helper.clone (GREEN_TRANSPORTATION_CARD),
            Helper.clone (ALTERNATE_ENERGY_CARD),
            Helper.clone (ENERGY_EFFICIENCY_CARD),

            // Predators
            // App only supports up to 4 apex predator cards
            Helper.clone (HUMAN_CARD),
            Helper.clone (HUMAN_CARD),
            Helper.clone (POLAR_BEAR_CARD),
            Helper.clone (POLAR_BEAR_CARD),
        ],
    }
}
